import * as React from "react";
import { Link, useLocation } from "react-router-dom";

// note: MUI Import
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

// note: component import
import { MCCirculerNonValueBV2 } from "components/Reusable/Progress";

// ==============================|| SCENE - NOT FOUND ||============================== //
function NotFoundPage() {
  const location = useLocation();

  return (
    <Container>
      <Box component={"main"} sx={{ marginTop: "10%" }}>
        <Stack spacing={1}>
          <Box component={"section"}>
            <Stack alignItems={"center"}>
              <Stack direction={"row"} justifyContent={"center"}>
                <Typography variant="h3">404</Typography>
              </Stack>
              <Typography variant="caption">
                Sorry, "{location?.pathname}" does not content
              </Typography>
            </Stack>
          </Box>
          <Box component={"section"}>
            <Stack direction={"row"} justifyContent={"center"}>
              BLANK
            </Stack>
          </Box>
          <Box component={"section"}>
            <Stack direction={"row"} justifyContent={"center"}>
              <Typography variant="body1">
                <Link to={-1} replace={true}>
                  Back
                </Link>
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Container>
  );
}

export default NotFoundPage;

export function ErrorPage() {
  return (
    <Container>
      <Stack justifyContent={"center"} alignItems={"center"}>
        <Box component={"main"}>
          <MCCirculerNonValueBV2 />
        </Box>
      </Stack>
    </Container>
  );
}
